export const NewsletterForm = {
	selectors: {
		forms: Array.prototype.slice.call(
			document.querySelectorAll(".js-newsletter-form")
		),
		errorTooltip: ".js-newsletter-form__error",
		errorTooltipContent: ".js-newsletter-form__error-content",
	},

	init: function () {
		const self = this;
		self.selectors.forms.forEach((form) => self.bindForm(form));
	},

	bindForm: function (form) {
		const self = this;

		const errorTooltip = form.querySelector(self.selectors.errorTooltip);
		const errorTooltipContent = form.querySelector(
			self.selectors.errorTooltipContent
		);

		// hide error
		if (errorTooltip) {
			errorTooltip.classList.add("u-hidden");
		}

		// hide error on form change
		form.querySelector("input").addEventListener("input", function () {
			errorTooltip.classList.add("u-hidden");
		});

		// bind submit
		form.addEventListener("submit", function (event) {
			event.preventDefault();

			const url = form.dataset.checkUrl;
			const message = form.dataset.checkMessage;
			const data = new FormData(form);

			self.ajaxRequest(url, data).then((result) => {
				if (result.success) {
					form.submit();
					return;
				}

				if (errorTooltip) {
					errorTooltipContent.innerHTML = message;
					errorTooltip.classList.remove("u-hidden");
				}
			}, self.errorHandler);
		});
	},

	ajaxRequest: function (_serviceURL, _data) {
		let promiseObj = new Promise(function (resolve, reject) {
			let requestURL = _serviceURL;
			let request = new XMLHttpRequest();

			request.open("POST", requestURL, true);
			request.responseType = "json";
			request.onreadystatechange = function () {
				if (request.readyState === 4) {
					if (request.status === 200) {
						resolve(request.response);
					} else {
						reject(request.status);
						console.log("xhr failed");
					}
				}
			};
			request.send(_data);
		});
		return promiseObj;
	},

	errorHandler: function (_statusCode) {
		console.error("Failed with status", _statusCode);
	},
};

NewsletterForm.init();
